import { useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { CopyPlus } from 'lucide-react';

import { useCoachSelf } from '@/data/coach';
import { getApiUrl } from '@/helpers/api';
import Spinner from '@/components/common/Spinner';
import { usePostDocument } from '@/data/document';
import { DOCUMENT_TYPE } from './enums';

const DocumentUploader = ({
  setApiError,
  ownerObj,
  onSuccess,
  documentType = DOCUMENT_TYPE.CERTIFICATION
}) => {
  const [submitting, setSubmitting] = useState(false);

  const fileInputRef = useRef(null);
  const postDocument = usePostDocument();
  const coach = useCoachSelf();

  const onUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    setSubmitting(true);
    setApiError('');

    try {
      const file = event.target.files[0];
      const { type, name } = file;
      // Replace spaces with dashes in the file name
      const sanitizedName = name.replace(/[^a-zA-Z0-9]+/g, '-');
      const fileExtension = type.split('/')[1];
      const baseName = sanitizedName.split('.').slice(0, -1).join('.');
      const fileName = `user/${
        coach.data.user.id
      }/${baseName}-${uuidv4()}.${fileExtension}`;

      // Get presigned url
      const response = await axios.post(
        `${getApiUrl()}/file/generate-presigned-url?type=document`,
        {
          fileName,
          fileType: type
        }
      );
      const presignedUrl = response.data.url;

      // Extract the path from the presigned URL
      const urlObject = new URL(presignedUrl);
      const documentPath = `${urlObject.origin}${urlObject.pathname}`;

      // Upload File
      await axios.put(presignedUrl, file, {
        headers: {
          'Content-Type': type
        }
      });

      // Store Document in database
      const payload = {
        ...ownerObj,
        type: documentType,
        documentUrl: documentPath,
        name
      };
      await postDocument(payload);
      await onSuccess();
      fileInputRef.current.value = '';
      setSubmitting(false);
    } catch (err) {
      setApiError(err);
      setSubmitting(false);
    }
  };

  return (
    <div
      className="flex justify-center items-center overflow-hidden rounded-sm border w-30"
      style={{ aspectRatio: '1 / 1' }}
    >
      <input
        type="file"
        onChange={handleFileChange}
        ref={fileInputRef}
        className="hidden"
      />
      {submitting && <Spinner />}
      {!submitting && <CopyPlus onClick={onUploadClick} />}
    </div>
  );
};

export default DocumentUploader;
